import SimpleCardDesign from "./SimpleCardDesign";
import TrippleStackDesign from "./TrippleStackDesign";
import CleanGridDesign from "./CleanGridDesign";
import MasonryShowcaseDesign from "./MasonryShowcaseDesign";
import InfoDuoBoxDesign from "./InfoDuoBoxDesign";
import TimelineDesign from "./TimelineDesign";
import HighlightPopCardDesign from "./HighlightPopCardDesign";
import { useSelector } from "react-redux";
import CardSimpleDesign from "./CardSimpleDesign";

function FacilitiesPageWrapper() {
  const sitedata = useSelector((store) => store.global.loginData);
  return (
    <>
      {sitedata?.theme_facilities === "card-triple-stack" ? (
        <TrippleStackDesign />
      ) : sitedata?.theme_facilities === "clean-grid-gallery" ? (
        <CleanGridDesign />
      ) : sitedata?.theme_facilities === "masonry-showcase" ? (
        <MasonryShowcaseDesign />
      ) : sitedata?.theme_facilities === "info-box-duo" ? (
        <InfoDuoBoxDesign />
      ) : sitedata?.theme_facilities === "highlight-pop-cards" ? (
        <HighlightPopCardDesign />
      ) : sitedata?.theme_facilities === "time-line" ? (
        <TimelineDesign />
      ) : sitedata?.theme_facilities === "simple-info-box" ? (
        <CardSimpleDesign />
      ) : (
        <SimpleCardDesign />
      )}

      



    </>
  );
}

export default FacilitiesPageWrapper;
